<template>
  <div>
    <div class="query-c" style="display: flex; align-items: center">
      查询：
      <Input
        style="width: 200px"
        v-model="keyword"
        @input="changeInput()"
        search
        placeholder="请输入产品名称"
      />
      <div style="display: flex; align-items: center; margin-left: 15px">
        <div style="width: 100px">产品分组:</div>
        <Select v-model="productGroupId" @on-change="changeInput()">
          <Option
            v-for="(data, index) in ProductGroupQueryList"
            :key="index"
            :value="data.id"
            >{{ data.name }}</Option
          >
        </Select>
      </div>
    </div>
    <br />
    <Table
      style="font-size: 20px"
      :content="self"
      border
      stripe
      :columns="columns1"
      :data="data1"
    >
      <template slot-scope="{ row, index }" slot="action">
        <Button
          style="background: #1e88e5; border-color: #1e88e5"
          type="error"
          size="small"
          @click="
            modal1 = true;
            dataIndex = index;
            amend(row.id);
          "
          >修改</Button
        >
        <Button
          style="background: #1e88e5; border-color: #1e88e5; margin-left: 10px"
          type="error"
          size="small"
          @click="
            modal11 = true;
            dataIndex = index;
            amend(row.id);
          "
          >分组</Button
        >
        <Button
          style="background: #1e88e5; border-color: #1e88e5; margin-left: 10px"
          type="error"
          size="small"
          @click="
            modal2 = true;
            dataIndex = index;
            AddProductLinks();
          "
          >添加产品链接</Button
        >
        <router-link style="width: 20%" :to="'/ProductUrl?id=' + row.id">
          <Button
            style="
              background: #1e88e5;
              border-color: #1e88e5;
              margin-left: 10px;
            "
            type="error"
            size="small"
            >查看产品链接</Button
          >
        </router-link>

        <Button
          style="
            background: #1e88e5;
            border-color: #1e88e5;
            margin-top: 10px;
            margin-left: 10px;
          "
          type="error"
          size="small"
          @click="
            shieldCity = true;
            dataIndex = index;
            getCityData = row;
            getCity();
          "
          >修改屏蔽城市</Button
        >
        <Button
          style="
            background: #1e88e5;
            border-color: #1e88e5;
            margin-top: 10px;
            margin-left: 10px;
          "
          type="error"
          size="small"
          @click="
            show = true;
            dataIndex = index;
            QueryBindUsers();
          "
          >已绑定用户列表</Button
        >
        <Button
          style="
            background: #1e88e5;
            border-color: #1e88e5;
            margin-top: 10px;
            margin-left: 10px;
          "
          type="error"
          size="small"
          @click="
            Delete = true;
            dataIndex = index;
          "
          >删除</Button
        >
      </template>
      <template slot-scope="{ row, index }" slot="inputLevel">
        <span v-if="row.inputLevel && row.inputLevel.indexOf('1') != -1"
          >姓名,</span
        >
        <span v-if="row.inputLevel && row.inputLevel.indexOf('3') != -1"
          >手机号,</span
        >
        <span v-if="row.inputLevel && row.inputLevel.indexOf('4') != -1"
          >验证码,</span
        >
        <span v-if="row.inputLevel && row.inputLevel.indexOf('2') != -1"
          >证件号码,</span
        >
      </template>
      <template slot-scope="{ row, index }" slot="img1">
        <img style="height: 90px; padding: 10px" :src="row.productLogo" />
      </template>
      <template slot-scope="{ row, index }" slot="img2">
        <img style="height: 150px" :src="row.exclusivePosters" />
      </template>
      <template slot-scope="{ row, index }" slot="img3">
        <img style="height: 150px" :src="row.spreadPosters" />
      </template>
    </Table>
    <Page
      style="margin-top: 10px"
      :total="total"
      @on-change="pagingSuery"
      show-elevator
    />
    <Modal
      width="40"
      v-model="modal2"
      title="添加产品链接及接口参数"
      @on-ok="ok()"
    >
      链接地址：
      <Input v-model="url" style="width: auto; margin-right: 15px" />
      <br />
      <br />接口请求参数 (json):
      <Input v-model="requestData" style="width: 370px; margin-right: 15px" />
      <br />
      <br />三方渠道编码:
      <Input
        type="text"
        v-model="t3rdCode"
        style="width: 100px; margin-right: 15px"
      />
      <br />
      <br />权重:
      <Input
        v-model="weight"
        type="number"
        style="width: 370px; margin-right: 15px"
      />
      <br />
      <br />请求头:
      <Input
        type="text"
        v-model="requestHeader"
        style="width: 100px; margin-right: 15px"
      />
      <br />
      <br />请求方式:
      <Input
        type="text"
        v-model="requestMethod"
        style="width: 100px; margin-right: 15px"
      />
      <br />
      <br />状态:
      <Select
        v-model="state"
        style="width: 200px; margin-left: 20px"
        placeholder="选择状态"
      >
        <Option
          v-for="item in AddState"
          :value="item.value"
          :key="item.value"
          >{{ item.label }}</Option
        >
      </Select>
    </Modal>

    <Modal v-model="modal11" title="修改分组" @on-ok="updated(dataIndex)">
      <div style="display: flex; align-items: center">
        <div style="width: 100px">产品分组:</div>
        <Select v-model="data1[dataIndex].productGroupId">
          <Option
            v-for="(data, index) in ProductGroupQueryList"
            :key="index"
            :value="data.id"
            >{{ data.name }}</Option
          >
        </Select>
      </div>
    </Modal>
    <Modal
      v-model="Delete"
      title="删除产品信息"
      @on-ok="DelProduct(data1[dataIndex])"
    >
      <div style="width: 100%; text-align: center">是否删除产品信息！</div>
    </Modal>
    <Modal v-model="show" title="已绑定用户列表">
      <Table
        style="font-size: 20px"
        border
        stripe
        :columns="columns"
        :data="QueryBindUsersData"
      >
        <template slot-scope="{ row, index }" slot="config">
          <Button
            style="background: red; border-color: red"
            type="error"
            size="small"
            @click="
              showDelete = true;
              updatedAdd = row;
            "
            >删除</Button
          >
        </template>
      </Table>

      <Page
        style="margin-top: 10px"
        :total="total1"
        @on-change="pagingSuery1"
        show-elevator
      />
      <Button
        style="background: red; border-color: red"
        type="error"
        size="small"
        @click="
          showadd = true;
          addphone = '';
        "
        >添加</Button
      >
    </Modal>

    <Modal
      v-model="showDelete"
      title="删除绑定用户"
      @on-ok="ProductDelBindUser()"
    >
      <div style="width: 100%; text-align: center">删除绑定用户</div>
    </Modal>
    <Modal @on-ok="ProductBindUser()" v-model="showadd" title="添加绑定用户">
      用户手机号：
      <Input v-model="addphone" style="width: auto; margin-right: 15px" />
    </Modal>
    <Button
      style="
        background: #2d8cf0;
        border-color: #2d8cf0;
        float: right;
        padding: 8px 30px;
        font-size: 20px;
      "
      type="error"
      size="small"
      @click="
        AddProduct = true;
        AddData = [];
        AddData = { sort: 50, type: 1, state: 1 };
      "
      >添加产品信息</Button
    >
    <Modal
      width="40"
      v-model="modal1"
      title="修改产品信息"
      @on-ok="updated(dataIndex)"
    >
      <div v-if="data1[dataIndex]">
        产品名称：
        <Input
          v-model="data1[dataIndex].productName"
          style="width: 400px; margin-right: 15px"
        />
        <br />
        <br />产品Logo：
        <input
          type="file"
          name="file"
          id="input_file1"
          @change="updatedShangc($event, 'productLogo')"
        />
        <Button
          style="
            background: #2d8cf0;
            border-color: #2d8cf0;
            float: right;
            padding: 8px 30px;
          "
          type="error"
          size="small"
          @click="DeleteImg('productLogo')"
          >删除</Button
        >
        <br />
        <br />

        <img style="width: 250px" :src="data1[dataIndex].productLogo" />
        <br />
        <br />专属海报：
        <input
          type="file"
          name="file"
          id="input_file2"
          @change="updatedShangc($event, 'exclusivePosters')"
        />
        <Button
          style="
            background: #2d8cf0;
            border-color: #2d8cf0;
            float: right;
            padding: 8px 30px;
          "
          type="error"
          size="small"
          @click="DeleteImg('exclusivePosters')"
          >删除</Button
        >
        <br />
        <br />
        <img style="width: 250px" :src="data1[dataIndex].exclusivePosters" />
        <br />
        <br />推广海报：
        <input
          type="file"
          name="file"
          id="input_file3"
          @change="updatedShangc($event, 'spreadPosters')"
        />
        <Button
          style="
            background: #2d8cf0;
            border-color: #2d8cf0;
            float: right;
            padding: 8px 30px;
          "
          type="error"
          size="small"
          @click="DeleteImg('spreadPosters')"
          >删除</Button
        >
        <br />
        <br />
        <img style="width: 250px" :src="data1[dataIndex].spreadPosters" />
        <br />
        <br />奖励金额：
        <Input
          type="number"
          v-model="data1[dataIndex].rewardAmount"
          style="width: 400px; margin-right: 15px"
        />
        <br />
        <br />降级金额：
        <Input
          type="number"
          v-model="data1[dataIndex].demotedAmount"
          style="width: 400px; margin-right: 15px"
        />
        <br />
        <br />
        <div style="display: flex; align-items: center; margin-top: 15px">
          <div>信息收集:</div>

          <!-- v-model="data1[dataIndex].inputLevelList" -->
          <CheckboxGroup @on-change="ccc" v-model="inputLevelList">
            <Checkbox label="1">姓名</Checkbox>
            <Checkbox label="2">证件号码</Checkbox>
            <Checkbox label="3">手机号</Checkbox>
            <Checkbox label="4">验证码</Checkbox>
          </CheckboxGroup>
        </div>

        <br />
        <br />
        <div style="display: flex; align-items: center">
          <div style="width: 100px">产品分组:</div>
          <Select v-model="data1[dataIndex].productGroupId">
            <Option
              v-for="(data, index) in ProductGroupQueryList"
              :key="index"
              :value="data.id"
              >{{ data.name }}</Option
            >
          </Select>
        </div>

        <br />
        <br />额外金额：
        <Input
          type="number"
          v-model="data1[dataIndex].extraAmount"
          style="width: 400px; margin-right: 15px"
        />
        <br />
        <br />有效期：
        <Input
          type="number"
          v-model="data1[dataIndex].reserve4"
          style="width: 400px; margin-right: 15px"
        />天
        <br />
        <br />
        类型：
        <Select
          v-model="data1[dataIndex].type1"
          style="width: 200px; margin-left: 20px"
          placeholder="选择类型"
        >
          <Option v-for="item in types" :value="item.value" :key="item.value">{{
            item.label
          }}</Option>
        </Select>
        <br />
        <br />
        状态：
        <Select
          v-model="data1[dataIndex].state1"
          style="width: 200px; margin-left: 20px"
          placeholder="选择状态"
        >
          <Option
            v-for="item in states"
            :value="item.value"
            :key="item.value"
            >{{ item.label }}</Option
          >
        </Select>
        <br />
        <br />结算周期：
        <Input
          v-model="data1[dataIndex].settlementCycle"
          style="width: 400px; margin-right: 15px"
        />
        <br />
        <br />结算规则：
        <Input
          v-model="data1[dataIndex].settlementRules"
          style="width: 400px; margin-right: 15px"
        />
        <br />
        <br />排序：
        <Input
          v-model="data1[dataIndex].sort"
          type="number"
          style="width: 400px; margin-right: 15px"
        />
        <br />
        <br />支持城市:
        <div
          v-for="(item, index) in data1[dataIndex].contentJson"
          :key="index"
          style="width: 400px; float: right; margin-bottom: 10px"
        >
          <Input
            v-model="item.title"
            style="width: 150px; margin-right: 15px"
          />:
          <Input
            v-model="item.content"
            style="width: 150px; margin-right: 15px"
          />
          <Button
            style="background: #2d8cf0; border-color: #2d8cf0; float: right"
            type="error"
            size="small"
            @click="DelSupport(index, data1[dataIndex].contentJson)"
            >删除</Button
          >
        </div>
        <Button
          style="background: #2d8cf0; border-color: #2d8cf0"
          type="error"
          size="small"
          @click="AddSupport(data1[dataIndex].contentJson)"
          >添加</Button
        >
      </div>
    </Modal>
    <Modal width="40" v-model="AddProduct" title="添加产品信息" @on-ok="Add()">
      产品名称：
      <Input
        v-model="AddData.productName"
        style="width: 400px; margin-right: 15px"
      />
      <br />
      <br />产品Logo：
      <input
        type="file"
        name="file"
        id="input_file1"
        @change="shangc($event, 'productLogo')"
      />
      <br />
      <br />
      <img style="width: 250px" :src="AddData.productLogo" />
      <br />
      <br />专属海报：
      <input
        type="file"
        name="file"
        id="input_file2"
        @change="shangc($event, 'exclusivePosters')"
      />
      <br />
      <br />
      <img style="width: 250px" :src="AddData.exclusivePosters" />
      <br />
      <br />推广海报：
      <input
        type="file"
        name="file"
        id="input_file3"
        @change="shangc($event, 'spreadPosters')"
      />
      <br />
      <br />
      <img style="width: 250px" :src="AddData.spreadPosters" />
      <br />
      <br />奖励金额：
      <br />
      <br />
      <Input
        type="number"
        v-model="AddData.rewardAmount1"
        style="width: 400px; margin-right: 15px"
      />
      <div style="display: flex; align-items: center">
        <div style="width: 100px">产品分组:</div>
        <Select v-model="AddData.productGroupId">
          <Option
            v-for="(data, index) in ProductGroupQueryList"
            :key="index"
            :value="data.id"
            >{{ data.name }}</Option
          >
        </Select>
      </div>
      <br />
      <br />降级金额：
      <Input
        type="number"
        v-model="AddData.demotedAmount1"
        style="width: 400px; margin-right: 15px"
      />
      <br />
      <br />
      <div style="display: flex; align-items: center; margin-top: 15px">
        <div>信息收集:</div>
        <CheckboxGroup v-model="AddData.inputLevelList">
          <Checkbox label="1">姓名</Checkbox>
          <Checkbox label="2">证件号码</Checkbox>
          <Checkbox label="3">手机号</Checkbox>
          <Checkbox label="4">验证码</Checkbox>
        </CheckboxGroup>
      </div>
      <br />
      <br />额外金额：
      <Input
        type="number"
        v-model="AddData.extraAmount1"
        style="width: 400px; margin-right: 15px"
      />
      <br />
      <br />有效期：
      <Input
        type="number"
        v-model="AddData.reserve4"
        style="width: 400px; margin-right: 15px"
      />天
      <br />
      <br />类型：
      <Select
        v-model="AddData.type"
        style="width: 200px; margin-left: 20px"
        placeholder="选择类型"
      >
        <Option v-for="item in types" :value="item.value" :key="item.value">{{
          item.label
        }}</Option>
      </Select>
      <br />
      <br />状态：
      <Select
        v-model="AddData.state"
        style="width: 200px; margin-left: 20px"
        placeholder="选择状态"
      >
        <Option v-for="item in states" :value="item.value" :key="item.value">{{
          item.label
        }}</Option>
      </Select>
      <br />
      <br />结算周期：
      <Input
        v-model="AddData.settlementCycle"
        style="width: 400px; margin-right: 15px"
      />
      <br />
      <br />结算规则：
      <Input
        v-model="AddData.settlementRules"
        style="width: 400px; margin-right: 15px"
      />
      <br />
      <br />排序：
      <Input
        v-model="AddData.sort"
        type="number"
        style="width: 400px; margin-right: 15px"
      />
      <br />
      <br />支持城市:
      <div
        v-for="(item, index) in SupportData"
        :key="index"
        style="width: 400px; float: right; margin-bottom: 10px"
      >
        <Input v-model="item.sort" style="width: 150px; margin-right: 15px" />:
        <Input
          v-model="item.content"
          style="width: 150px; margin-right: 15px"
        />
        <Button
          style="background: #2d8cf0; border-color: #2d8cf0; float: right"
          type="error"
          size="small"
          @click="DelSupport(index)"
          >删除</Button
        >
      </div>
      <Button
        style="background: #2d8cf0; border-color: #2d8cf0"
        type="error"
        size="small"
        @click="AddSupport()"
        >添加</Button
      >
    </Modal>
    <Modal width="40" v-model="shieldCity" title="添加修改屏蔽城市">
      <Tree
        @on-check-change="ConfigCity"
        ref="tree"
        :data="treeData"
        show-checkbox
      ></Tree>
    </Modal>
  </div>
</template>

<script>
import { api } from "../biz/api";
export default {
  name: "Product",

  data() {
    return {
      productGroupId: "",
      ProductGroupQueryList: [],
      inputLevelList: [],
      showDelete: false,
      modal11: false,
      updatedAdd: {},
      self: this,
      shieldCity: false,
      Delete: false,
      addphone: "",
      QueryBindUsersData: [],
      show: false,
      showadd: false,
      SupportData: [],
      keyword: "",
      t3rdCode: "",
      requestHeader: "",
      total: 0,
      total1: 0,
      getCityData: {},
      treeData: [],
      AddData: { sort: 50, type: 1, state: 1 },
      AddState: [
        {
          value: "0",
          label: "未使用",
        },
        {
          value: "1",
          label: "使用",
        },
      ],
      states: [
        {
          value: 0,
          label: "下架",
        },
        {
          value: 1,
          label: "正常",
        },
        {
          value: 2,
          label: "接口正常",
        },
      ],
      types: [
        {
          value: 1,
          label: "链接",
        },
        {
          value: 2,
          label: "接口",
        },
      ],
      AddProduct: false,
      modal2: false,
      pageNow: 0,
      pageNow1: 0,
      columns: [
        {
          title: "用户id",
          align: "center",
          key: "id",
        },
        {
          title: "手机号",
          align: "center",
          key: "phone",
        },
        {
          title: "操作",
          key: "address",
          align: "center",
          width: "150px",
          slot: "config",
        },
      ],
      columns1: [
        {
          title: "id",
          align: "center",
          key: "id",
          width: 200,
        },
        {
          title: "产品名称",
          align: "center",
          key: "productName",
          width: 200,
        },
        {
          title: "产品分组",
          align: "center",
          key: "groupName",
          width: 200,
        },

        {
          title: "产品Logo",
          align: "center",
          width: "150px",
          slot: "img1",
          key: "productLogo",
          width: 200,
        },
        {
          title: "信息收集",
          className: "fontcolor",
          align: "center",
          slot: "inputLevel",
          width: 200,
        },
        // {
        //   title: "专属海报",
        //   slot: "img2",
        //   width: "200px",
        //   align: "center",
        //   key: "exclusivePosters"
        // },
        // {
        //   title: "推广海报",
        //   slot: "img3",
        //   width: "200px",
        //   align: "center",
        //   key: "spreadPosters"
        // },
        {
          title: "奖励金额(元)",
          align: "center",
          key: "rewardAmount",
          width: 120,
        },
        {
          title: "降级金额(元)",
          align: "center",
          key: "demotedAmount",
          width: 120,
        },
        {
          title: "额外金额(元)",
          align: "center",
          key: "extraAmount",
          width: 120,
        },
        {
          title: "类型",
          key: "type",
          align: "center",
          width: 100,
        },
        {
          title: "状态",
          key: "state",
          align: "center",
          width: 100,
        },
        {
          title: "结算周期",
          align: "center",
          key: "settlementCycle",
          width: 150,
        },
        {
          title: "结算规则",
          align: "center",
          key: "settlementRules",
          width: 150,
        },
        {
          title: "操作",
          key: "address",
          align: "center",
          width: "150px",
          slot: "action",
          width: 350,
          fixed: "right",
        },
      ],
      data1: [{}],
      dataIndex: 0,
      url: "",
      state: 0,
      requestData: "",
      weight: "",
      requestMethod: "",
      rowCity: {},
      AllCity: {},
      modal1: false,
    };
  },
  mounted: function () {
    this.getData();
    api
      .ProductGroupQueryList({
        pageNow: 1,
        pageSize: 999999,
      })
      .then((res) => {
        this.ProductGroupQueryList = res.body.data.list;
      });
  },
  methods: {
    ProductDelBindUser() {
      api
        .ProductDelBindUser({
          id: this.data1[this.dataIndex].id,
          userId: this.updatedAdd.id,
        })
        .then((res) => {
          alert(res.body.message);
          this.QueryBindUsers();
        });
    },
    ccc(i) {
      this.data1[this.dataIndex].inputLevelList = this.inputLevelList;
    },
    ProductBindUser() {
      api
        .ProductBindUser({
          id: this.data1[this.dataIndex].id,
          phone: this.addphone,
        })
        .then((res) => {
          alert(res.body.message);
          this.QueryBindUsers();
        });
    },
    async getCity() {
      this.rowCity = await api.SelectAllScreening({
        pageSize: "9999",
        productId: this.getCityData.id,
      });
      this.AllCity = await api.GetProvincesAll();
      if (!this.rowCity.body.data) {
        this.rowCity.body.data = {};
      }
      this.formatting(this.AllCity.body.data, this.rowCity.body.data.list);
      this.treeData = this.AllCity.body.data;
    },
    QueryBindUsers() {
      api
        .QueryBindUsers({
          pageNow: this.pageNow1,
          pageSize: "10",
          id: this.data1[this.dataIndex].id,
        })
        .then((res) => {
          this.total1 = res.body.data.total;
          this.QueryBindUsersData = res.body.data.list;
        });
    },
    AddProductLinks() {
      this.url = "";
      this.requestData = "";
      this.weight = "";
      this.state = "";
      this.t3rdCode = "";
      this.requestMethod = "";
      this.requestHeader = "";
    },

    amend(id) {
      api.GetIdProduct(id).then((res) => {
        if (res.body.data.content) {
          res.body.data.contentJson = JSON.parse(res.body.data.content);
        } else {
          res.body.data.contentJson = [];
        }
        res.body.data.rewardAmount = res.body.data.rewardAmount / 100;
        res.body.data.demotedAmount = res.body.data.demotedAmount / 100;
        res.body.data.extraAmount = res.body.data.extraAmount / 100;
        res.body.data.state1 = res.body.data.state;
        res.body.data.type1 = res.body.data.type;

        if (res.body.data.state === 0) {
          res.body.data.state = "下架";
        }
        if (res.body.data.state == 1) {
          res.body.data.state = "正常";
        }
        if (res.body.data.state == 2) {
          res.body.data.state = "接口正常";
        }
        if (res.body.data.type === 1) {
          res.body.data.type = "链接";
        } else {
          res.body.data.type = "接口";
        }
        this.data1[this.dataIndex] = res.body.data;
        if (this.data1[this.dataIndex].inputLevel) {
          this.data1[this.dataIndex].inputLevelList =
            this.data1[this.dataIndex].inputLevel.split(",");
          this.inputLevelList = this.data1[this.dataIndex].inputLevelList;
        }

        this.$forceUpdate();
      });
    },
    AddSupport(data) {
      if (data) {
        data.push({ title: "", content: "" });
      } else {
        this.SupportData.push({ title: "", content: "" });
      }
      this.$forceUpdate();
    },
    DelSupport(index, data) {
      if (data) {
        data.splice(index, 1);
      } else {
        this.SupportData.splice(index, 1);
      }
      this.$forceUpdate();
    },
    formatting(AllCity, rowCity) {
      AllCity.forEach((element) => {
        if (element.cities) {
          element.children = element.cities;
          this.formatting(element.children, rowCity);
        }
        if (rowCity) {
          rowCity.forEach((rowElement) => {
            if (element.province == rowElement.areaName) {
              element.checked = true;
              element.selectId = rowElement.id;
            }
          });
        }
        element.title = element.province;
      });
    },
    ConfigCity(res, index) {
      if (index.checked) {
        api
          .AddScreening({
            productId: this.data1[this.dataIndex].id,
            cityName: index.province,
            cityGbCode: index.provinceidone,
          })
          .then((res) => {});
      } else {
        this.rowCity.body.data.list.forEach((element) => {
          if (index.province == element.areaName) {
            api.DelScreening({ id: index.selectId }).then((res) => {});
          } else {
            this.formatting(
              this.AllCity.body.data,
              this.rowCity.body.data.list
            );
            this.treeData = this.AllCity.body.data;
            index.checked = false;
          }
        });
      }
    },
    ok() {
      api
        .AddProductUrl({
          productId: this.data1[this.dataIndex].id,
          url: this.url,
          t3rdCode: this.t3rdCode,
          state: this.state,
          requestData: this.requestData,
          requestHeader: this.requestHeader,
          weight: this.weight,
          requestMethod: this.requestMethod,
        })
        .then((res) => {
          this.$layer.alert(res.body.message);
          this.getData();
        });
    },
    DeleteImg(index) {
      api.ProductDel(this.data1[this.dataIndex][index]).then((data) => {
        this.data1[this.dataIndex][index] = "";
      });
    },
    updatedShangc(e, index) {
      let that = this;

      var reader = new FileReader();
      var AllowImgFileSize = 2100000;
      let file = document.getElementById(e.srcElement.id).files[0];

      var imgUrlBase64;
      if (file) {
        //将文件以Data URL形式读入页面
        imgUrlBase64 = reader.readAsDataURL(file);
        reader.onload = (e) => {
          this.formData = e.target.files; //创建一个forData
          var formData = new FormData();
          formData.append("file", file);
          api.ProductDel(this.data1[this.dataIndex][index]).then((data) => {
            api.ProductUploads(formData).then((res) => {
              this.data1[this.dataIndex][index] = res.body.data[0].path;
              var files = document.getElementsByName("file");
              files.forEach((element) => {
                element.value = ""; //虽然file的value不能设为有字符的值，但是可以设置为空值
              });
              this.$forceUpdate();
            });
          });
        };
      }
    },
    DelProduct(index) {
      api.DelProduct({ id: this.data1[this.dataIndex].id }).then((res) => {
        this.getData();
      });
    },
    shangc(e, index) {
      let that = this;
      var reader = new FileReader();
      var AllowImgFileSize = 2100000;
      let file = document.getElementById(e.srcElement.id).files[0];
      var imgUrlBase64;
      if (file) {
        //将文件以Data URL形式读入页面
        imgUrlBase64 = reader.readAsDataURL(file);
        reader.onload = (e) => {
          this.formData = e.target.files; //创建一个forData
          var formData = new FormData();
          formData.append("file", file);
          api.ProductUploads(formData).then((res) => {
            this.AddData[index] = res.body.data[0].path;
            this.$forceUpdate();
          });
        };
      }
    },
    changeInput() {
      this.pageNow = 0;
      this.getData();
    },
    getData() {
      api
        .GetAllProduct({
          pageNow: this.pageNow,
          pageSize: "10",
          productGroupId: this.productGroupId,
          keyword: this.keyword,
        })
        .then((res) => {
          if (res.body.data) {
            this.total = res.body.data.total;
            this.data1 = res.body.data.list;
            this.data1.forEach((element) => {
              if (element.content) {
                element.contentJson = JSON.parse(element.content);
              } else {
                element.contentJson = [];
              }
              element.rewardAmount = element.rewardAmount / 100;
              element.demotedAmount = element.demotedAmount / 100;
              element.extraAmount = element.extraAmount / 100;

              if (element.state === 0) {
                element.state = "下架";
              }
              if (element.state == 1) {
                element.state = "正常";
              }
              if (element.state == 2) {
                element.state = "接口正常";
              }
              if (element.type === 1) {
                element.type = "链接";
              } else {
                element.type = "接口";
              }
            });
            for (let i = 0; i < this.data1.length; i++) {
              if (this.data1[i].inputLevel) {
                this.data1[i].inputLevelList =
                  this.data1[i].inputLevel.split(",");
              }
            }
            this.$forceUpdate();
          } else {
            this.total = 0;
            this.data1 = [{}];
          }
        });
    },
    pagingSuery(pageNow) {
      this.pageNow = pageNow;
      this.getData();
    },
    pagingSuery1(pageNow) {
      this.pageNow1 = pageNow;
      this.QueryBindUsers();
    },
    updated(index) {
      let data = this.data1[this.dataIndex];
      this.data1[this.dataIndex].inputLevel = "";
      this.data1[this.dataIndex].inputLevelList.forEach((element) => {
        this.data1[this.dataIndex].inputLevel =
          this.data1[this.dataIndex].inputLevel + element + ",";
      });

      this.data1[this.dataIndex].inputLevel = this.data1[
        this.dataIndex
      ].inputLevel.slice(0, this.data1[this.dataIndex].inputLevel.length - 1);
      data.rewardAmount = data.rewardAmount * 100;
      data.demotedAmount = data.demotedAmount * 100;
      data.extraAmount = data.extraAmount * 100;
      data.content = JSON.stringify(data.contentJson);
      data.state = data.state1;
      data.type = data.type1;
      this.$forceUpdate();
      api.UpdateProduct(data).then((res) => {
        this.getData();
      });
    },

    Add() {
      this.AddData.rewardAmount = this.AddData.rewardAmount1 * 100;
      this.AddData.demotedAmount = this.AddData.demotedAmount1 * 100;
      this.AddData.extraAmount = this.AddData.extraAmount1 * 100;
      this.AddData.content = JSON.stringify(this.SupportData);
      this.AddData.inputLevel = "";
      this.AddData.inputLevelList.forEach((element) => {
        this.AddData.inputLevel = this.AddData.inputLevel + element + ",";
      });

      this.AddData.inputLevel = this.AddData.inputLevel.slice(
        0,
        this.AddData.inputLevel.length - 1
      );
      this.$forceUpdate();
      api.AddProduct(this.AddData).then((res) => {
        this.getData();
      });
    },
  },
};
</script>

<style scoped>
</style>
